import * as _4 from 'lodash4';
import { ICourseGrupInfo, ISearchParentCourse } from '../components/smart_search/smart_catalog_search';
export class ApSmartSearchServant {
  static shouldHideAddToTermAction(courseGroupInfo: ICourseGrupInfo) {
    return _4.gt(_4.toNumber(courseGroupInfo.termId), 0);
  }
  static isLargeCourseGroupSmartSearch(courseGroupInfo: ICourseGrupInfo) {
    return !_4.isEmpty(courseGroupInfo.courseGroupValue);
  }
  static isWildcardSmartSearch(courseGroupInfo: ICourseGrupInfo) {
    return courseGroupInfo.isWildCard;
  }

  static isPlanningFromTerm(courseGroupInfo: ICourseGrupInfo) {
    return ApSmartSearchServant.isLargeCourseGroupSmartSearch(courseGroupInfo) && _4.gt(courseGroupInfo.termId, 0);
  }
  static isInSwapMode(courseGroupInfo: ICourseGrupInfo) {
    return courseGroupInfo.isInSwapMode;
  }
  static isCoursegroupLocked(courseGroupInfo: ICourseGrupInfo) {
    return _4.get(courseGroupInfo, 'parentCourse.plannedCourse.is_locked', false);
  }
  static getSwapCommandParams(courseGroupInfo: ICourseGrupInfo) {
    const parentCourse = ApSmartSearchServant.getLargeCourseGroupParentCourse(courseGroupInfo);
    const courseToRemove = _4.get(parentCourse, 'plannedCourse', {});
    const courseToAdd = { id: null };
    const programSlotToAdd = _4.get(parentCourse, 'programSlot', {});
    const termId: number = _4.toNumber(courseGroupInfo.termId);
    return { courseToRemove, courseToAdd, programSlotToAdd, termId };
  }
  static getLargeCourseGroupTermId(courseGroupInfo: ICourseGrupInfo) {
    return courseGroupInfo.termId;
  }
  static getLargeCourseGroupParentCourse(courseGroupInfo: ICourseGrupInfo) {
    return _4.get(courseGroupInfo, 'parentCourse', {}) as ISearchParentCourse;
  }
  static getPlanCommandParams(courseGroupInfo: ICourseGrupInfo) {
    const parentCourse = ApSmartSearchServant.getLargeCourseGroupParentCourse(courseGroupInfo);
    const termId = _4.toNumber(ApSmartSearchServant.getLargeCourseGroupTermId(courseGroupInfo));
    const courseGroup = {
      course_group: _4.get(parentCourse, 'programSlot.course_group', ''),
      id: _4.get(parentCourse, 'programSlot._course_group_id', ''),
      program_slot: _4.get(parentCourse, 'programSlot.id', ''),
      term: termId
    };
    const programSlot = { ...parentCourse.programSlot, _term_id: termId };
    const courseToPlan = { id: null };
    return { programSlot, courseGroup, courseToPlan };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/servants/ap_smart_search_servant.ts